module.exports = __webpack_public_path__ + "static/staff_of_swarming_insects-6eb5897a4c86b053431e732c071c2f43.jpeg";